import React,{useState,useEffect} from "react";
import {TableDatePicker,btnSetColor_CBack,getWaUrlPath} from '../function_lib/common_lib';
import {FileUploaderV1} from '../function_lib/upload_lib_file';
export const Multi_Member_Edit_Form = ({ formFields, index,onRemove }) => {
  let appUrlMedPath=getWaUrlPath();
    useEffect(()=>{
      //alert(index);
        //alert(JSON.stringify(formFields));
        FileUploaderV1(this,function(data,msg){
         //alert("i m done");
        });
      },[index])
  return (
    <div className="fields-body member-block11 border11 p-3 mb-3">
      <h5>Form {index + 1}
      {index!==0?
      <a href={"javascript:void(0)"} onClick={onRemove} className="float-right p-2 btn-secondary">
  <i class="fa fa-times" aria-hidden="true"></i>
</a>:''}
      </h5>
     
      <div className="row">
      <input type="hidden" name={`lsImages_${index}`} id={`lsImages_${index}`}/>
      {Array.isArray(formFields) && formFields?.map((formItem,formIndex)=>{
                                    if(formItem.field_type==="text"){
                                        return <>
                                        <div className="col-lg-12 col-md-12">
                                          <div className="billing-info mb-4">
                                              <label  class="flabel">{formItem["field_name"]}</label>
                                              <input className="form-control f-input required" defaultValue={formItem["value"]} id={`members[${index}][${formItem.id}]`} name={`members[${index}][${formItem.id}]`} type="text" />
                                          </div>
                                      </div>
                                       </>
                                    }if(formItem.field_type==="number"){
                                      return <>
                                      <div className="col-lg-12 col-md-12">
                                        <div className="billing-info mb-4">
                                            <label  class="flabel">{formItem["field_name"]}</label>
                                            <input className="form-control f-input required" defaultValue={formItem["value"]} id={`members[${index}][${formItem.id}]`} name={`members[${index}][${formItem.id}]`} type="number" />
                                        </div>
                                    </div>
                                     </>
                                  }
                                    else  if(formItem.field_type==="dropdown"){
                                        let listOptions=[];
                                        if(formItem?.option_if_any.trim()!==""){
                                            listOptions=formItem.option_if_any.split(',');
                                        }
                                        return <>
                                         <div className="col-lg-12">
                                       <div className="billing-select mb-4">
                                           <label  class="flabel">{formItem["field_name"]}</label>
                                           <select className="form-control f-select select_target f-select required" resp_dest="getStateShipping" id={`members[${index}][${formItem.id}]`} name={`members[${index}][${formItem.id}]`}>
                                               <option>Select {formItem["field_name"]}</option>
                                               {listOptions.map((optionItem,optionIndex)=>{
                                                return <option selected={formItem["value"]===optionItem} value={optionItem}>{optionItem}</option>
                                               })}
                                             
                                           </select>
                                       </div>
                                   </div>
                                        </>
                                    }else if(formItem.field_type==="file"){
                                        return <>
                                        <div className="col-lg-6 col-md-6">
                                          <div className="billing-info mb-4">
                                              <label  class="flabel">{formItem["field_name"]}</label>
                                              <input type="file" name={`lsImages_${index}_${formItem.id}`} id={`lsImages_${index}_${formItem.id}`} ref_img="ImageThumbBackNew" thumbnail_div={"oth_img_div"} lsElement={`lsImages_${index}`} thumbnail={`imgLibThumb_${formItem["id"]}_${index}`} accept="image/*" capture="camera" size={1000000000} 
                        className='updImgThumb'
                        />
                                              <button class="file-zone _brFileThumb updthumb"   onClick={(e) => {
    e.preventDefault();
    e.stopPropagation();
  }} setTo={`lsImages_${index}_${formItem.id}`}>
                       
                        <div class="file-icon">
                          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                            <polyline points="17 8 12 3 7 8"/>
                            <line x1="12" y1="3" x2="12" y2="15"/>
                          </svg>
                        </div>
                        <div class="file-text">
                          <div class="ft-main">Choose file to upload</div>
                          <div class="ft-sub">PDF, JPG, PNG up to 5MB</div>
                        </div>
                      </button>

                                             
                                              
                                          </div>
                                          <div class={"row upload_image_css "+ `imgLibThumb_${formItem["id"]}_${index}`}>

                                          </div>
                                      </div>
                                      {typeof formItem.value!=="undefined" && formItem.value!==""?
                                     <div class="col-lg-6 col-md-6">
                                     <div class="col-lg-3 col-md-3 col-sm-3 col-6 lsthumb image_thumb_parent">
        <i class="fa fa-close icon-close _removeBtn" param3="thumDiv" aria-hidden="true"></i>
          <a class="gallery-item" href="flImg"><img style={{"maxWidth":"150px"}} src={appUrlMedPath+formItem["value"]}/></a>
          </div>
          <a href={appUrlMedPath + formItem.value} download target="_blank">Download File</a>
                                     </div>:'No file uploaded'}
                                       </>
                                    }else if(formItem.field_type==="date"){
                                        return <>
                                        <div className="col-lg-12 col-md-12">
                                          <div className="billing-info mb-4">
                                              <label  class="flabel">{formItem["field_name"]}</label>
                                              <TableDatePicker  class="form-control required" refName={`members[${index}][${formItem.id}]`}/>
                                              {/* <input type="file" className="form-control required" id="s_name" name="s_name" /> */}
                                          </div>
                                      </div>
                                        </>
                                    }
                                   
                                })}    
      </div>
    </div>
  );
};

export default Multi_Member_Edit_Form;